/* @flow */
import cx from 'classnames';
import * as React from 'react';

import Text from 'components/Text.jsx';

import './styles/Copy.scss';

import type { TextAlign, TextSize } from 'components/Text.jsx';

type Props = {
  align?: TextAlign,
  children: React.Node,
  className?: string,
  columns?: number,
  size?: TextSize,
};

export default class Copy extends React.Component<Props> {
  static defaultProps = {
    align: 'left',
  };

  render() {
    const { align, children, className, columns, size, ...others } = this.props;
    const style = columns ? { columnCount: columns } : {};

    return (
      <Text
        {...others}
        align={align}
        element="div"
        size={size}
        style={style}
        className={cx(
          'Copy',
          align === 'center' && 'Copy--center',
          size && `Copy--${size}`,
          className
        )}>
        {children}
      </Text>
    );
  }
}
